// Mapeia valores internos de estágio (growthStage) para rótulos em português
export const STAGE_LABELS = {
    seedling: 'Muda',
    vegetative: 'Vegetativo',
    flowering: 'Floração',
    harvested: 'Colhada'
};

export function stageLabel(stage) {
    return STAGE_LABELS[stage] || stage || '—';
}
